import ReportsNav from "../../pages/Dashboard/Reports/ReportsNav";
import ReportsIndex from "../../pages/Dashboard/Reports/ReportsIndex";
import DoctorActivityReport from "../../pages/Dashboard/Reports/DoctorActivityReport";
import LabOverallReport from "../../pages/Dashboard/Reports/LabOverallReport";
import ReceptionRevenueReport from "../../pages/Dashboard/Reports/ReceptionRevenueReport";
import PharmacyReport from "../../pages/Dashboard/Reports/PharmacyReport";
import RadiologyReport from "../../pages/Dashboard/Reports/RadiologyReport";
import LaboratoryReport from "../../pages/Dashboard/Reports/LaboratoryReport";
import SurgeryReport from "../../pages/Dashboard/Reports/SurgeryReport";

const reportsRoutes = {
  path: "/reports",
  element: <ReportsNav />,
  children: [
    { path: "/reports", element: <ReportsIndex /> },
    { path: "/reports/doctor-activity", element: <DoctorActivityReport /> },
    { path: "/reports/lab-overall", element: <LabOverallReport /> },
    { path: "/reports/reception-revenue", element: <ReceptionRevenueReport /> },
    { path: "/reports/pharmacy", element: <PharmacyReport /> },
    { path: "/reports/radiology", element: <RadiologyReport /> },
    { path: "/reports/laboratory", element: <LaboratoryReport /> },
    { path: "/reports/surgery", element: <SurgeryReport /> },
  ],
};

export default reportsRoutes;
